import { Box } from '@chakra-ui/react';
import React from 'react';

import { DashboardMode } from '../hooks/DataMetadataContextType';
import { Select } from '~/packages/common-frontend/components/Select';
import { ALL_STATUS_OPTIONS } from '~/valleyBank/domains/page/ui/utils';

export const ValleyBankPreviewPicker = ({
  dashboardMode,
  setDashboardMode,
}: {
  dashboardMode: DashboardMode;
  setDashboardMode: (newdashboardMode: DashboardMode) => void;
}) => {
  return (
    <Box w="200px" bgColor="white" borderRadius="8px">
      <Select<DashboardMode>
        value={dashboardMode}
        options={ALL_STATUS_OPTIONS}
        onChange={(value) => value && setDashboardMode(value)}
      />
    </Box>
  );
};
